import type { SymbolCodepoints } from '@umodeapporg/ui/components/UI/MaterialSymbol/types';

import { PendenciaItem } from '../interfaces/implantacao';

/**
 * Query key that asks a screen to open showing ONLY what the roadmap counted. The value
 * is the item itself, so the destination never has to guess which pendency sent it there.
 *
 * It exists because "Resolver" has one promise to keep: the number on the card is the
 * number of lines the destination shows. A link that only opened the right tab broke that
 * promise in the worst way, landing on an EMPTY de-para while the card said 7.
 */
export const PENDENCIA_PARAM = 'pendencia';

/**
 * Query key que abre a LISTA da implantacao nas Configuracoes. A Implantacao deixou de
 * ser aba e virou a faixa do topo, entao a lista completa e um estado do endereco: sem
 * isto, o "Resolver" dos parametros nao teria para onde apontar.
 */
export const IMPLANTACAO_PARAM = 'implantacao';

/** O unico valor que o `?implantacao=` carrega: a lista aberta. */
export const IMPLANTACAO_ABERTA = 'aberta';

/** Whether this screen was opened by the "Resolver" of a given roadmap item. */
export function abriuPelaPendencia(valorDoParam: string, item: PendenciaItem): boolean {
  return valorDoParam === item;
}

/**
 * Para onde cada item leva, com o filtro JA aplicado: quem clica cai na lista daquele
 * assunto, nao na tela inteira. Os filtros sao os que a tela de destino ja le da URL
 * (`fonte` da Carteira, `bloco` das Configuracoes, `activeTab` das abas) mais o
 * `pendencia` acima, que TODA tela de destino aqui interpreta.
 *
 * Mora aqui, e nao no cartao da Inicio, porque a secao Implantacao das Configuracoes
 * mostra a MESMA lista: dois mapas iguais sairiam do ar no primeiro item novo.
 */
export const IMPLANTACAO_DESTINOS: Record<PendenciaItem, string> = {
  FERIADOS_A_CONFIRMAR: `/settings?bloco=feriados&${PENDENCIA_PARAM}=FERIADOS_A_CONFIRMAR`,
  // Os processos COM o problema, nao a aba de Maquinas, que mostra o parque que existe.
  PROCESSOS_SEM_MAQUINA: `/cadastros?activeTab=processos&${PENDENCIA_PARAM}=PROCESSOS_SEM_MAQUINA`,
  // A ficha "Validação: Sugerida" da propria barra de filtros, nada especial: quem quer a
  // lista toda tira a ficha, e o que a tela conta e o que o cartao contou.
  SEQUENCIAS_A_VALIDAR: '/sequencias?validacao=sugerida',
  OPS_SEM_TEMPO: '/ops?fonte=NENHUMA',
  MARCAS_SEM_GORDURA: `/cadastros?activeTab=clientesMarcas&${PENDENCIA_PARAM}=MARCAS_SEM_GORDURA`,
  // Resolve-se na propria lista da Implantacao, que abre com o valor atual e o
  // "Validar" de cada parametro.
  PARAMETROS_A_CONFIRMAR: `/settings?${IMPLANTACAO_PARAM}=${IMPLANTACAO_ABERTA}&${PENDENCIA_PARAM}=PARAMETROS_A_CONFIRMAR`,
};

export const IMPLANTACAO_ICONS: Record<PendenciaItem, SymbolCodepoints> = {
  FERIADOS_A_CONFIRMAR: 'event_busy',
  PROCESSOS_SEM_MAQUINA: 'precision_manufacturing',
  SEQUENCIAS_A_VALIDAR: 'checklist',
  OPS_SEM_TEMPO: 'timer_off',
  MARCAS_SEM_GORDURA: 'local_offer',
  PARAMETROS_A_CONFIRMAR: 'tune',
};
